import { render, staticRenderFns } from "./commandbar.vue?vue&type=template&id=23f42ae8&"
import script from "./commandbar.vue?vue&type=script&lang=js&"
export * from "./commandbar.vue?vue&type=script&lang=js&"
import style0 from "./commandbar.vue?vue&type=style&index=0&id=23f42ae8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports